export enum SupportedFileTypes {
  IMAGE = 'image/*',
}
